import React, { useState } from "react";
import emojis from "../../../images/icons/emojis.svg";
import emojis_1 from "../../../images/icons/emojis_1.svg";
import emojis_2 from "../../../images/icons/emojis_2.svg";
import emojis_3 from "../../../images/icons/emojis_3.svg";
import emojis_4 from "../../../images/icons/emojis_4.svg";

function EmojiFeedback({ rating, ratingOptions }) {
    const [emojiSelected, setEmojiSelected] = useState(null);
    const [emojiText, setEmojiText] = useState("Choose your experience");
    const [starSelected, setStarSelected] = useState(-1);
    const [starText, setStarText] = useState("Choose your experience");
    const [hoveredStar, setHoveredStar] = useState(-1);

    const handleFeedbackSelection = (emojiNumber, emojiText) => {
        setEmojiText(emojiText);
        setEmojiSelected(emojiNumber);
    };

    const handleStarFeedbackSelection = (starNumber, starText) => {
        setStarText(starText);
        setStarSelected(starNumber);
    };

    const renderStars = () => {
        return (
            <div className="d-flex">
                {[1, 2, 3, 4, 5].map((starNumber) => (
                    <div
                        key={starNumber}
                        className="cursor-pointer mx-1 transition-0-2-bounce"
                        onClick={() => handleStarFeedbackSelection(ratingOptions[starNumber - 1].index_num, `${ratingOptions[starNumber - 1].options_desc} ${ratingOptions[starNumber - 1].options_desc2}`)}
                        onMouseEnter={() => setHoveredStar(starNumber)}
                        onMouseLeave={() => setHoveredStar(-1)}
                    >
                        <span className={starNumber <= (hoveredStar !== -1 ? hoveredStar : starSelected) ? "fa-solid fa-star text-warning" : "fa-regular fa-star text-secondary"} style={{ fontSize: "2rem" }}></span>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="py-3">
            <p className="text-wafaa-black-1 d-flex flex-column font-size-18">
                <span style={{ fontSize: "1rem" }}>{rating.description}</span>
                <span>{rating.secondLanguage}</span>
            </p>
            <input type="hidden" name="rating_id[]" value={rating.rating_id ?? ""} />
            <input type="hidden" name="client_id[]" value={rating.Client_id ?? ""} />
            <input type="hidden" name="rating_name[]" value={rating.description ?? ""} />
            <input type="hidden" name="rating_type[]" value={rating.rating_type ?? ""} />
            <input type="hidden" name="star_selected[]" value={starSelected ?? ""} />
            <input type="hidden" name="emoji_selected[]" value={emojiSelected ?? ""} />

            {rating.rating_type === "Star" ? (
                <>
                    {renderStars()}
                    <i className="text-wafaa-black-1">{starText}</i>
                </>
            ) : (
                <>
                    <div className="justify-content-between m-0 p-0 row w-90">
                        <img
                            className={"col-2 p-0 img-fluid transition-0-2-bounce " + (emojiSelected === ratingOptions[0].options_id ? "opacity-100 transform-scale-1-2" : "opacity-25")}
                            onClick={() => handleFeedbackSelection(ratingOptions[0].options_id, `${ratingOptions[0].options_desc} ${ratingOptions[0].options_desc2}`)}
                            src={emojis}
                            alt="Emoji"
                        />
                        <img
                            className={"col-2 p-0 img-fluid transition-0-2-bounce " + (emojiSelected === ratingOptions[1].options_id ? "opacity-100 transform-scale-1-2" : "opacity-25")}
                            onClick={() => handleFeedbackSelection(ratingOptions[1].options_id, `${ratingOptions[1].options_desc} ${ratingOptions[1].options_desc2}`)}
                            src={emojis_1}
                            alt="Emoji"
                        />
                        <img
                            className={"col-2 p-0 img-fluid transition-0-2-bounce " + (emojiSelected === ratingOptions[2].options_id ? "opacity-100 transform-scale-1-2" : "opacity-25")}
                            onClick={() => handleFeedbackSelection(ratingOptions[2].options_id, `${ratingOptions[2].options_desc} ${ratingOptions[2].options_desc2}`)}
                            src={emojis_2}
                            alt="Emoji"
                        />
                        <img
                            className={"col-2 p-0 img-fluid transition-0-2-bounce " + (emojiSelected === ratingOptions[3].options_id ? "opacity-100 transform-scale-1-2" : "opacity-25")}
                            onClick={() => handleFeedbackSelection(ratingOptions[3].options_id, `${ratingOptions[3].options_desc} ${ratingOptions[3].options_desc2}`)}
                            src={emojis_3}
                            alt="Emoji"
                        />
                        <img
                            className={"col-2 p-0 img-fluid transition-0-2-bounce " + (emojiSelected === ratingOptions[4].options_id ? "opacity-100 transform-scale-1-2" : "opacity-25")}
                            onClick={() => handleFeedbackSelection(ratingOptions[4].options_id, `${ratingOptions[4].options_desc} ${ratingOptions[4].options_desc2}`)}
                            src={emojis_4}
                            alt="Emoji"
                        />
                    </div>
                    <i className="text-wafaa-black-1">{emojiText}</i>
                </>
            )}
            <div className="my-3 w-90 d-none">
                <textarea name="other_feedback[]" placeholder="Suggest anything we can improve" className="shadow border p-2 rounded-3 w-100" />
            </div>
        </div>
    );
}

export default EmojiFeedback;
